import { memo } from 'react';

import { DateFilter, type DateFilterProps } from '~/components/Filters/DateFilter/DateFilter';
import { type DateRangeType } from '~/store/filters/types';

export type CreatedDateFilterProps = {
  dateType: DateRangeType;
} & Omit<DateFilterProps, 'selectedType'>;

export const CreatedDateFilter = memo(
  ({ dateType, endDate, onTypeChange, onStartDateChange, startDate, onEndDateChange }: CreatedDateFilterProps) => {
    return (
      <DateFilter
        startDate={startDate}
        endDate={endDate}
        selectedType={dateType}
        onStartDateChange={onStartDateChange}
        onEndDateChange={onEndDateChange}
        onTypeChange={onTypeChange}
      />
    );
  },
);

CreatedDateFilter.displayName = 'CreatedDateFilter';
